<template>
    <div>
        <div
            v-for="(item, index) in contentList"
            :ref="`content-${index}`"
            :key="index"
            class="cc-sub-container content"
        >
            <div
                class="cc-content-container"
                :class="{'right': index % 2 === 1}"
            >
                <div class="cc-content-text">
                    <div class="cc-content-title">{{ item.title }}</div>
                    <div class="cc-content-desc">{{ isMobile && item.wiseDesc ? item.wiseDesc : item.desc }}</div>
                </div>
                <div class="cc-video-container">
                    <video
                        :ref="`video-${index}`"
                        controlsList="nodownload"
                        :src="item.video"
                        playsInline="true"
                        webkit-playsinline="true"
                        x-webkit-airplay="allow"
                        x5-playsinline="true"
                        x5-video-player-type="h5"
                        x5-video-orientation="portraint"
                        t7-video-player-type="inline"
                        class="cc-video"
                        preload="auto"
                        autoplay=""
                        muted
                        loop=""
                    ></video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {contentList} from '../config/indexV2';

export default {
    name: 'cc-content',
    data() {
        return {
            contentList
        };
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        const refNames = Object.keys(this.$refs);
        const videos = [];
        const contents = [];
        refNames.forEach(item => {
            if (item.startsWith('video-')) {
                videos.push(this.$refs[item][0]);
            }
            if (item.startsWith('content-')) {
                contents.push(this.$refs[item][0]);
            }
        });
        this.contentRefs = contents;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5 // 设置可见性阈值，表示当视频元素至少50%可见时触发回调
        };

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    video.play();
                }
                else {
                    const video = entry.target;
                    video.pause();
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        videos.forEach(video => {
            observer.observe(video);
        });
    }
};

</script>

<style lang="less" scoped>
.cc-nav {
    &-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 1200px;
        height: 128px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid #FFFFFF;
        box-shadow: 0px 3.42857px 28.2857px rgba(190, 196, 207, 0.28);
        backdrop-filter: blur(8.14286px);
        border-radius: 118px;
        margin: 28px auto 0;
        padding: 28 3px 0;
        background: #fff;
    }
    &-item-container {
        flex: 1;
        display: flex;
        justify-content: center;
        border-right: 1px solid #E2E6F0;
        &:last-child {
            border-right: none;
        }
    }
    &-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: transform 300ms ease;
        &:hover {
            transform: translateY(-16px);
        }
    }
    &-icon {
        width: 64px;
        height: 64px;
        background-size: 100% 100%;
        margin-right: 12px;
    }
    &-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        color: #282C33;
    }
    &-desc {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #848B99;
        margin-top: 3px;
    }

}

.cc-sub-container {
    width: 100%;
    // max-width: 1920px;
    margin: 0 auto;
    background-color: #fff;
    &.content {
        background-image: url('../assets/mobilev2-content-bg.png');
        background-size: cover;
        overflow: hidden;
    }
}
.cc-content {
    &-container {
        width: 1200px;
        margin: 0 auto;
        height: 753px;
        position: relative;
        padding-top: 200px;
        &.right {
            .cc-content-text {
                margin-left: 750px;
            }
            .cc-video-container {
                left: -70px;
            }
        }
    }
    &-text {
        width: 435px;
        min-width: 436px;
        .cc-nav-button {
            width: 160px;
            height: 56px;
            border-radius: 47px;
            border: 1px #3A5BFD solid;
            font-weight: 500;
            font-size: 20px;
            line-height: 56px;
            text-align: center;
            color: #3A5BFD;
            margin-top: 72px;
            cursor: pointer;
            &.active:hover {
                background-color: #ebf2ff;
            }
            &.disabled {
                cursor: not-allowed;
                color: #A8B0BF;
                border-color: #A8B0BF;
            }
        }
    }
    &-text-right {
        // padding: 48px 0 0 115px;
    }
    &-title {
        font-weight: 600;
        font-size: 60px;
        line-height: 84px;
        color: #0A0B0D;
    }
    &-desc {
        margin-top: 16px;
        font-weight: 400;
        font-size: 20px;
        line-height: 32px;
        color: #282C33;
    }

}
.cc-video-container {
    width: 785px;
    height: 557px;
    background: url('../assets/videoBg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: -75px;
    top: 98px;
    .cc-video {
        width: 645px;
        height: 420px;
        border-radius: 36px;
        position: absolute;
        top: 64px;
        left: 70px;
    }
}
</style>